// react
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGoBack } from 'hooks/useGoBack';
import { ROUTES } from 'router';

// store
import { useLazyGetServiceQuery } from 'store/api/cms';
import { Service as ServiceType } from '@karehero/models';

// components
import ServiceContentPage from '@karehero/llama/components/pages/ServiceContent/ServiceContent';

// tracking
import { TrackingEvent, useTracking } from 'hooks';

/**
 * Service shows the content of a Service from Sanity.
 */
export const Service = () => {
  // state
  const [service, setService] = useState<ServiceType>();

  // hooks
  const { track } = useTracking();
  const { careCircleId, serviceId } = useParams();
  const [getService, { isLoading: isServiceLoading }] =
    useLazyGetServiceQuery();
  const navigate = useNavigate();
  const goBack = useGoBack();

  // effects
  useEffect(() => {
    if (!serviceId) {
      navigate(ROUTES.SERVICE);
      return;
    }
    (async () => {
      const { data, error } = await getService(serviceId);
      if (error) {
        navigate(ROUTES.SERVICE);
        return;
      }
      if (!data) return;
      setService(data);

      track(TrackingEvent.ServiceViewed, {
        id: data._id,
        title: data.title,
      });
    })();
  }, [serviceId, careCircleId, getService, navigate, track]);

  return (
    <ServiceContentPage
      content={service}
      isLoading={!service ? true : isServiceLoading}
      navigate={navigate}
      backPath={ROUTES.SERVICE}
      onAction={() => navigate(ROUTES.BOOK_CALL)}
      onBack={goBack}
    />
  );
};

export default Service;
